import { ViewModel,View, ObservableArray } from "binder"
import  { SendNotificationView } from "./sendNotification-view"
import { IPopup } from "../../windowContainer/IPopup";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { UserSearchViewModel } from "src/security/userManipulation/userSearsh/userSearch-viewModel";
import { WindowViewModel } from "../../windowContainer/windowContainer-viewModel";

export class SendNotificationViewModel extends WindowViewModel{
    public getTitle(): string {
        return "ارسال پیام";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.notifications = ObservableArray.create<singleNotification>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()
    }
    GetDefaultView(): View <ViewModel> {
        return new SendNotificationView();
    }
    public getTypeId(): string {
        return "VM-FCE12D80-A134-4CEB-91F8-ADFACD5F2CB9"
    }

    public set notifications(v: ObservableArray<singleNotification>) { this._notifications = v; } public get notifications(): ObservableArray<singleNotification> { return this._notifications;} private _notifications: ObservableArray<singleNotification>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UserNotifications/ListSentNotifications',{
                FurtherQueryInfo:filteringInformation
            });
            this.notifications.update(...result.Notifications.map((x,i)=>{
                let r = new singleNotification(this);
                r.index = (result.PaginationInfo.CurrentPage-1)*result.PaginationInfo.PageSize+i+1;
                r.id = x.Id;
                r.title = x.Title;
                r.body = x.Body;
                r.alertType = x.AlertType;
                r.creationTime = moment.utc(x.CreationTime);
                r.receiverName = x.ReceiverName;
                r.showTime = x.ShowTime ? moment.utc(x.ShowTime) : null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return null;
        } finally {
            this.isLoading = false;
        }
    }

    async sendNotification():Promise<void>{
        let popup:notificationSender = new notificationSender(this);
        let result =await this.showPopup(popup);
        if(result){
            this.refresh();
        }
    }
}

export class singleNotification extends ViewModel implements IPopup{
    public getTypeId(): string {return 'notification';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    closePopup(result?: any) {
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body;} private _body: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set alertType(v: number) { this._alertType = v; } public get alertType(): number { return this._alertType;} private _alertType: number;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName;} private _receiverName: string;
    public set showTime(v: moment.Moment) { this._showTime = v; } public get showTime(): moment.Moment { return this._showTime;} private _showTime: moment.Moment;

    showDetail(){
        this.requestShowingPopup(this)
    }

    back(){
        this.closePopup()
    }
}

export class notificationSender extends ViewModel implements IPopup{
    public getTypeId(): string {return 'notificationSender';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:SendNotificationViewModel) {
        super(parent);
        this._parent = parent;
        this.receiverUser = new UserSearchViewModel(this);
    }

    private _parent:SendNotificationViewModel;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body;} private _body: string;
    public set receiverUser(v: UserSearchViewModel) { this._receiverUser = v; } public get receiverUser(): UserSearchViewModel { return this._receiverUser;} private _receiverUser: UserSearchViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    closePopup(result?: any) {    
    }

    back():void{
        this.closePopup()
    }

    async send():Promise<void>{
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/UserNotifications/SendNotificationByUser', {
                Title: this.title,
                Body: this.body,
                UserId: this.receiverUser.selectedItem.id
            });

            if(serverResult.IsSuccessful){
                await this.messageBoxConfirmSuccess("پیام شما به موفقیت ارسال شد.", "ارسال پیام");
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
}
